const line1 = document.getElementById("line1");
const line2 = document.getElementById("line2");
const count1 = document.getElementById("count1");
const count2 = document.getElementById("count2");
const stickerTexts = document.querySelectorAll(".sticker-text");
const themeGrid = document.getElementById("themeGrid");
const collage = document.querySelector(".collage");

let selectedTheme = 1;

function updateText() {
  const text1 = line1.value.trim();
  const text2 = line2.value.trim();

  count1.textContent = `${line1.value.length} / 17`;
  count2.textContent = `${line2.value.length} / 17`;

  stickerTexts.forEach(box => {
    box.classList.remove("one-line", "two-line", "text-medium", "text-small");

    if (text1 && !text2) {
      box.innerHTML = text1;
      box.classList.add("one-line");
    } else if (!text1 && text2) {
      box.innerHTML = text2;
      box.classList.add("one-line");
    } else {
      box.innerHTML = `${text1}<br>${text2}`;
      box.classList.add("two-line");
    }

    const longest = Math.max(text1.length, text2.length);

    if (longest > 18) {
      box.classList.add("text-small");
    } else if (longest > 14) {
      box.classList.add("text-medium");
    }
  });
}

function createThemes() {
  themeGrid.innerHTML = "";

  for (let i = 1; i <= 20; i++) {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "theme-btn";

    if (i === selectedTheme) {
      btn.classList.add("active");
    }

    const img = document.createElement("img");
    img.src = window.themePreviewImages[i - 1];
    img.alt = `Theme ${i}`;

    btn.appendChild(img);

    btn.addEventListener("click", () => {
      selectedTheme = i;

      document.querySelectorAll(".theme-btn").forEach(b => {
        b.classList.remove("active");
      });

      btn.classList.add("active");
      updateStickerImages(i);
    });

    themeGrid.appendChild(btn);
  }
}

function updateStickerImages(themeIndex) {
  collage.className = `collage theme-${themeIndex}`;

  const stickers = document.querySelectorAll(".sticker img");
  const themeImages = window.themeStickerImages[String(themeIndex)];

  stickers.forEach((img, index) => {
    const imgNo = index < 10 ? index : 9;
    img.src = themeImages[imgNo];
  });
}

line1.addEventListener("input", updateText);
line2.addEventListener("input", updateText);

createThemes();
updateStickerImages(1);
updateText();


// ================================
// STORA NAMNLAPPAR - SHOPIFY CART
// ================================

let storaQuantity = 1;

const storaQtyMinus = document.getElementById("storaQtyMinus");
const storaQtyPlus = document.getElementById("storaQtyPlus");
const storaQtyValue = document.getElementById("storaQtyValue");
const storaAddToCartBtn = document.getElementById("storaAddToCartBtn");
const storaVariantId = document.getElementById("storaVariantId");

storaQtyPlus.addEventListener("click", () => {
  storaQuantity++;
  storaQtyValue.textContent = storaQuantity;
});

storaQtyMinus.addEventListener("click", () => {
  if (storaQuantity > 1) {
    storaQuantity--;
    storaQtyValue.textContent = storaQuantity;
  }
});

storaAddToCartBtn.addEventListener("click", () => {
  const text1 = line1.value.trim();
  const text2 = line2.value.trim();

  storaAddToCartBtn.disabled = true;
  storaAddToCartBtn.innerHTML = "<span>🛒</span> Lägger till...";

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      id: Number(storaVariantId.value),
      quantity: storaQuantity,
      properties: {
        "Rad 1": text1,
        "Rad 2": text2,
        "Tema": "Theme " + selectedTheme,
        "Produkt": "Stora namnlappar"
      }
    })
  })
    .then(res => {
      if (!res.ok) throw new Error("Cart error");
      return res.json();
    })
    .then(() => {
      storaAddToCartBtn.innerHTML = "<span>🛒</span> Tillagd ✓";

      setTimeout(() => {
        window.location.href = "/cart";
      }, 700);
    })
    .catch(err => {
      console.error(err);
      storaAddToCartBtn.disabled = false;
      storaAddToCartBtn.innerHTML = "<span>🛒</span> Försök igen";
    });
});